module.exports = __webpack_public_path__ + "static/media/Saptham1.0d8d82e8.svg";